import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaidPaymentOrdersList  {
    _originalTypeClassName = "zERP.BO.PaidPaymentOrdersList";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaidPaymentOrdersList.translate = translateService;
}
this.PaymentOrders = [];
this.Id = null;
this.DateCreated = null;
this.Name = null;
this.Description = null;
this.Number = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateCreated:any;
Name:any;
Description:any;
Number:any;
PaymentOrders:any;
Entity:any;
File:any;
static setPaymentOrders = ($this, items) => {
                if (items == null) items = [];
                if ($this.PaymentOrders == null) $this.PaymentOrders = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PaymentOrders.length > 0) {
                    Domain.PaidPaymentOrdersList.removePaymentOrders($this, $this.PaymentOrders[0]);
                }

                Domain.PaidPaymentOrdersList.addManyPaymentOrders($this, copyItems);
            }
static addManyPaymentOrders = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaidPaymentOrdersList.addPaymentOrders($this, items[i]);
                }
            }
static addPaymentOrders = ($this, item) => {
                if ($this.PaymentOrders == null) $this.PaymentOrders = [];
                if (item == null || $this.PaymentOrders.indexOf(item) > -1) return;
                $this.PaymentOrders.push(item);
if (item.PaymentOrderPaymentList != $this) {
Domain.PaymentOrder.setPaymentOrderPaymentList(item, $this);
}
}
static addRangePaymentOrders = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaidPaymentOrdersList.addPaymentOrders($this, item));
            }
static removePaymentOrders = ($this, item) => {
                if ($this == null || $this.PaymentOrders == null || $this.PaymentOrders.indexOf(item) === -1) return;
                var _index = $this.PaymentOrders.indexOf(item);
                $this.PaymentOrders.splice(_index, 1);
item.PaymentOrderPaymentList = null;
}
static clearPaymentOrders = ($this) => { $this.PaymentOrders = null; }
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setFile = ($this, value) => {
var oldValue = $this.File;
$this.File = value;
if (value != null) {
}
}

static GetFileContents($this: any): any{let lines = [];
let header = [];
header?.add("Ένταλμα Πληρωμής");
header?.add("Σειρά Έντάλματος");
header?.add("Ημ/νια Δημιουργίας");
header?.add("Τρόπος Πληρωμής");
header?.add("Από Λογαριαμό");
header?.add("Σε Λογαριασμό");
header?.add("Λογαριαμός Μετρητών");
header?.add("Ποσό");
lines?.add(CLMS.Framework.String.Join(", ", header));
for (let _ipaymentOrder = 0; _ipaymentOrder < ($this?.PaymentOrders == null ? 0 : $this?.PaymentOrders.length); _ipaymentOrder++) {let paymentOrder = $this?.PaymentOrders[_ipaymentOrder];for (let _ipaymentLine = 0; _ipaymentLine < (paymentOrder?.Payment?.Lines == null ? 0 : paymentOrder?.Payment?.Lines.length); _ipaymentLine++) {let paymentLine = paymentOrder?.Payment?.Lines[_ipaymentLine];let line = [];line?.add(paymentOrder?.Number?.toString());line?.add(paymentOrder?.Series?.Name);line?.add(CLMS.Framework.DateTime.ToString(paymentOrder?.DateIssued, "dd/MM/yyyy"));line?.add(paymentLine?.PaymentMethod?.Name);line?.add(paymentLine?.BankAccountFrom?.IBAN);line?.add(paymentLine?.BankAccountTo?.IBAN);line?.add(paymentLine?.CashAccount?.Name);line?.add(paymentLine?.PaymentAmount?.toString());lines?.add(CLMS.Framework.String.Join(", ", line));}}
return CLMS.Framework.String.Join("\r\n", lines);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}